import { motion } from 'framer-motion';
import { sectionAnimVariants } from '../../../constants/animationVariants';
import { useRoleContext } from '../../../contexts/RoleProvider';
import useRolesActions from '../../../hooks/APIHooks/users/useRolesActions';
import useCheckUserFeaturePermissions from '../../../hooks/useCheckUserFeaturePermissions';
import AcademiaNotFound from '../../CommonComps/AcademiaNotFound';
import SetupCard from '../../CommonComps/Cards/SetupCard';
import SetupCardBodyInfo from '../../CommonComps/Cards/SetupCardBodyInfo';
import AcademiaLoading from '../../CommonComps/Loadings/AcademiaLoading';
import PageHeader from '../../CommonComps/Titles/PageHeader';
import CreateRoleAction from './CreateRoleAction';

const ShowAllRoles = () => {
  // integration of context hooks here
  const { setTargetedRole, setShowDeleteModal, setShowEditModal } =
    useRoleContext();

  // integration of custom API hooks here
  const { getRoleListHandler } = useRolesActions('roleList');

  console.log('ROLE LIST: ', getRoleListHandler.data?.data);

  // integration of custom hooks here
  const { featureBasedPermissions } = useCheckUserFeaturePermissions('role');

  // rendering show all roles section component here
  return (
    <section>
      {getRoleListHandler.isLoading ? (
        <AcademiaLoading />
      ) : getRoleListHandler.isSuccess ? (
        featureBasedPermissions?.includes('READ') ? (
          <>
            <PageHeader
              headerText='All Roles'
              additionalComponent={
                <CreateRoleAction
                  hasCreatePermission={featureBasedPermissions.includes(
                    'CREATE'
                  )}
                />
              }
            />

            <motion.div
              variants={sectionAnimVariants}
              initial='initial'
              animate='animate'
              className='grid grid-cols-1 md:grid-cols-3 xl:grid-cols-4 gap-5'
            >
              {getRoleListHandler.data.data.map((role) => (
                <SetupCard
                  key={role.id}
                  title={role.role_name}
                  label={
                    <>
                      {role.role_name}{' '}
                      <span className='text-gray-400 text-base'>
                        ({role.role_count})
                      </span>
                    </>
                  }
                  editBtnTitle='Update Role'
                  deleteBtnTitle='Delete Role'
                  disableDeleteBtn={!!role.role_count}
                  disableDeleteBtnTitle='Cannot delete role which has users!'
                  showDeleteModalHandler={
                    featureBasedPermissions.includes('DELETE')
                      ? () => {
                          setTargetedRole(role);
                          setShowDeleteModal(true);
                        }
                      : undefined
                  }
                  showEditModalHandler={
                    featureBasedPermissions.includes('UPDATE')
                      ? () => {
                          setTargetedRole(role);
                          setShowEditModal(true);
                        }
                      : undefined
                  }
                >
                  <div className='border-t border-dashed border-legal-dark-blue'>
                    <SetupCardBodyInfo
                      label='Description'
                      info={role.description}
                    />
                  </div>
                </SetupCard>
              ))}
            </motion.div>
          </>
        ) : (
          <AcademiaLoading />
        )
      ) : getRoleListHandler.isError ? (
        <AcademiaNotFound message='Failed to load roles data!!' />
      ) : null}
    </section>
  );
};

export default ShowAllRoles;
